/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const executeApprovedGraphMutationBodyCanonicalMutationAddNodesItemClientIdMax = 36;

export const executeApprovedGraphMutationBodyCanonicalMutationAddNodesItemClientIdRegExp =
  new RegExp('^[a-z0-9._:-]+$');
export const executeApprovedGraphMutationBodyCanonicalMutationAddNodesItemContentTypeClientIdMax = 36;

export const executeApprovedGraphMutationBodyCanonicalMutationAddNodesItemContentTypeClientIdRegExp =
  new RegExp('^[a-z0-9._:-]+$');
export const executeApprovedGraphMutationBodyCanonicalMutationAddNodesItemTypeDescriptionMax = 2000;

export const executeApprovedGraphMutationBodyCanonicalMutationEditNodesItemContentTypeClientIdMax = 36;

export const executeApprovedGraphMutationBodyCanonicalMutationEditNodesItemContentTypeClientIdRegExp =
  new RegExp('^[a-z0-9._:-]+$');
export const executeApprovedGraphMutationBodyCanonicalMutationEditNodesItemTypeDescriptionMax = 2000;

export const executeApprovedGraphMutationBodyCanonicalMutationRootClientIdsItemMax = 36;

export const executeApprovedGraphMutationBodyCanonicalMutationRootClientIdsItemRegExp = new RegExp(
  '^[a-z0-9._:-]+$',
);
export const executeApprovedGraphMutationBodyCanonicalMutationSetEdgesItemFromClientIdMax = 36;

export const executeApprovedGraphMutationBodyCanonicalMutationSetEdgesItemFromClientIdRegExp =
  new RegExp('^[a-z0-9._:-]+$');
export const executeApprovedGraphMutationBodyCanonicalMutationSetEdgesItemToClientIdMax = 36;

export const executeApprovedGraphMutationBodyCanonicalMutationSetEdgesItemToClientIdRegExp =
  new RegExp('^[a-z0-9._:-]+$');

export const ExecuteApprovedGraphMutationBody = zod.object({
  canonicalMutation: zod.object({
    addNodes: zod
      .array(
        zod.object({
          clientId: zod
            .string()
            .min(1)
            .max(executeApprovedGraphMutationBodyCanonicalMutationAddNodesItemClientIdMax)
            .regex(executeApprovedGraphMutationBodyCanonicalMutationAddNodesItemClientIdRegExp)
            .describe(
              'Caller-supplied temporary node reference, unique within the request. Used to wire edges and to look up the created UUID in the response. Use lowercase letters, numbers, dots, underscores, colons, or hyphens.',
            ),
          contentTypeClientId: zod
            .string()
            .min(1)
            .max(
              executeApprovedGraphMutationBodyCanonicalMutationAddNodesItemContentTypeClientIdMax,
            )
            .regex(
              executeApprovedGraphMutationBodyCanonicalMutationAddNodesItemContentTypeClientIdRegExp,
            )
            .optional()
            .describe(
              'Caller-supplied temporary node reference, unique within the request. Used to wire edges and to look up the created UUID in the response. Use lowercase letters, numbers, dots, underscores, colons, or hyphens.',
            ),
          contentTypeUuid: zod.uuid().optional().describe('UUID v4 identifier'),
          occurredAt: zod.string().optional(),
          subjectUuid: zod.uuid().nullish().describe('UUID v4 identifier'),
          typeDescription: zod
            .string()
            .min(1)
            .max(executeApprovedGraphMutationBodyCanonicalMutationAddNodesItemTypeDescriptionMax)
            .optional(),
          typeName: zod.string().min(1).optional(),
          value: zod
            .object({
              booleanValue: zod.boolean().nullish(),
              dateValue: zod.string().nullish(),
              datetimeValue: zod.string().nullish(),
              numericValue: zod.number().nullish(),
              stringValue: zod.string().nullish(),
            })
            .optional(),
          valueType: zod.enum(['STRING', 'NUMERIC', 'BOOLEAN', 'DATE', 'DATETIME']).optional(),
          variant: zod.enum(['TYPE', 'INSTANCE']).optional(),
        }),
      )
      .optional(),
    deleteLineageUuids: zod.array(zod.uuid().describe('UUID v4 identifier')).optional(),
    editNodes: zod
      .array(
        zod.object({
          contentTypeClientId: zod
            .string()
            .min(1)
            .max(
              executeApprovedGraphMutationBodyCanonicalMutationEditNodesItemContentTypeClientIdMax,
            )
            .regex(
              executeApprovedGraphMutationBodyCanonicalMutationEditNodesItemContentTypeClientIdRegExp,
            )
            .optional()
            .describe(
              'Caller-supplied temporary node reference, unique within the request. Used to wire edges and to look up the created UUID in the response. Use lowercase letters, numbers, dots, underscores, colons, or hyphens.',
            ),
          contentTypeUuid: zod.uuid().optional().describe('UUID v4 identifier'),
          contentUuid: zod.uuid().describe('UUID v4 identifier'),
          occurredAt: zod.string().optional(),
          subjectUuid: zod.uuid().nullish().describe('UUID v4 identifier'),
          typeDescription: zod
            .string()
            .min(1)
            .max(executeApprovedGraphMutationBodyCanonicalMutationEditNodesItemTypeDescriptionMax)
            .optional(),
          typeName: zod.string().min(1).optional(),
          value: zod
            .object({
              booleanValue: zod.boolean().nullish(),
              dateValue: zod.string().nullish(),
              datetimeValue: zod.string().nullish(),
              numericValue: zod.number().nullish(),
              stringValue: zod.string().nullish(),
            })
            .optional(),
          variant: zod.enum(['TYPE', 'INSTANCE']).optional(),
        }),
      )
      .optional(),
    ownership: zod.enum(['user_owned', 'agent_owned']),
    removeEdges: zod
      .array(
        zod.object({
          fromContentUuid: zod.uuid().describe('UUID v4 identifier'),
          toContentUuid: zod.uuid().describe('UUID v4 identifier'),
        }),
      )
      .optional(),
    rootClientIds: zod
      .array(
        zod
          .string()
          .min(1)
          .max(executeApprovedGraphMutationBodyCanonicalMutationRootClientIdsItemMax)
          .regex(executeApprovedGraphMutationBodyCanonicalMutationRootClientIdsItemRegExp)
          .describe(
            'Caller-supplied temporary node reference, unique within the request. Used to wire edges and to look up the created UUID in the response. Use lowercase letters, numbers, dots, underscores, colons, or hyphens.',
          ),
      )
      .optional()
      .describe(
        'Added root INSTANCE client IDs only. TYPE nodes and contained child INSTANCE nodes are not roots.',
      ),
    rootContentUuids: zod.array(zod.uuid().describe('UUID v4 identifier')).optional(),
    setEdges: zod
      .array(
        zod.object({
          carbonCopy: zod.boolean().optional(),
          certainty: zod.enum(['ASSERTED', 'INFERRED', 'SUGGESTED']).optional(),
          edgeDescription: zod.string().nullish(),
          edgeKey: zod.string().nullish(),
          edgeType: zod.enum(['CONTAINS', 'RELATES_TO', 'INCLUDES']),
          fromClientId: zod
            .string()
            .min(1)
            .max(executeApprovedGraphMutationBodyCanonicalMutationSetEdgesItemFromClientIdMax)
            .regex(executeApprovedGraphMutationBodyCanonicalMutationSetEdgesItemFromClientIdRegExp)
            .optional()
            .describe(
              'Caller-supplied temporary node reference, unique within the request. Used to wire edges and to look up the created UUID in the response. Use lowercase letters, numbers, dots, underscores, colons, or hyphens.',
            ),
          fromContentUuid: zod.uuid().optional().describe('UUID v4 identifier'),
          maxCount: zod.int().nullish(),
          minCount: zod.int().nullish(),
          position: zod.int().nullish(),
          toClientId: zod
            .string()
            .min(1)
            .max(executeApprovedGraphMutationBodyCanonicalMutationSetEdgesItemToClientIdMax)
            .regex(executeApprovedGraphMutationBodyCanonicalMutationSetEdgesItemToClientIdRegExp)
            .optional()
            .describe(
              'Caller-supplied temporary node reference, unique within the request. Used to wire edges and to look up the created UUID in the response. Use lowercase letters, numbers, dots, underscores, colons, or hyphens.',
            ),
          toContentUuid: zod.uuid().optional().describe('UUID v4 identifier'),
        }),
      )
      .optional(),
    source: zod
      .object({
        messageContentUuid: zod.uuid().optional().describe('UUID v4 identifier'),
        reachThreadId: zod.uuid().optional().describe('UUID v4 identifier'),
      })
      .optional(),
    subjectUuid: zod.uuid().optional().describe('UUID v4 identifier'),
  }),
  mutationHash: zod.string().min(1),
  reachThreadId: zod.uuid().optional().describe('UUID v4 identifier'),
  toolCallId: zod.string().min(1),
});

export type ExecuteApprovedGraphMutationBody = zod.input<typeof ExecuteApprovedGraphMutationBody>;
export type ExecuteApprovedGraphMutationBodyOutput = zod.output<
  typeof ExecuteApprovedGraphMutationBody
>;
